module.exports = __webpack_public_path__ + "img/search.1d82a9e2.jpeg";